// Sample Category mappings. Useful for display and random generation.
// Based on https://docs.google.com/spreadsheets/d/11t0kQrdFeLs9EOCyTs4jZ1kG72jpEbZQ/edit#gid=504527822

// note: an instrument can have multiple parent categories
export const MelodicParentCategories = {
  Bass: ['Bass Guitar', 'Synth Bass', 'Bass', '808'],
  Synth: [
    'Pluck',
    'Pad',
    'Synth Bass',
    'Synth Keys',
    'Synth Guitar',
    'Synth Strings',
    'Melody',
    'Lead',
    'Chords',
    'Synth',
    'Arp',
    'Analog',
    'Bell',
    'Stabs'
  ],
  Wind: [
    'Brass Hit',
    'Trumpet',
    'Clarinet',
    'Saxophone',
    'Flugelhorn',
    'Flute',
    'Woodwind',
    'Brass'
  ],
  Vocals: ['Vocoder', 'Female', 'Male', 'Spoken Word', 'Phrases', 'Vox', 'Vocals'],
  Keys: ['Piano', 'Organ'],
  Strings: ['Cello', 'Violin', 'Double Bass', 'Harp', 'Synth Strings'],
  Guitar: ['Acoustic Guitar', 'Electric Guitar', 'Synth Guitar'],
  SFX: ['SFX']
}

export const getMelodicParentCategory = (child: string) => {
  const melodicCategoryKeys = Object.keys(MelodicParentCategories)
  for (let i = 0; i < melodicCategoryKeys.length; i++) {
    const category = melodicCategoryKeys[i]
    if ((MelodicParentCategories[category] as string[]).includes(child)) return category
  }

  return null
}

export const DrumParentCategories = {
  OneShot: {
    Loop: new Array<string>(),
    Drums: new Array<string>(),
    Hats: ['Closed', 'Open'],
    Kick: new Array<string>(),
    Cymbal: ['Ride', 'Crash'],
    Snare: new Array<string>(),
    Snap: new Array<string>(),
    Rim: new Array<string>(),
    Clap: new Array<string>(),
    Woodblock: new Array<string>(),
    Percussion: [
      'Tom',
      'Snap',
      'Timbales',
      'Bongos',
      'Shakers',
      'Tambourine',
      'Conga',
      'Djembe',
      'Stomp',
      'Clave',
      'Perc',
      'Cowbell',
      'Bottle'
    ]
  },
  Loops: {
    Breaks: new Array<string>(),
    Fills: new Array<string>(),
    Grooves: new Array<string>()
  }
}

export const getDrumParentCategory = (child: string) => {
  const oneShots = Object.keys(DrumParentCategories.OneShot)
  const loops = Object.keys(DrumParentCategories.Loops)
  for (let i = 0; i < oneShots.length; i++) {
    const category = oneShots[i]
    if (DrumParentCategories.OneShot[category].includes(child) || category === child)
      return ['OneShot', category]
  }
  for (let i = 0; i < loops.length; i++) {
    const category = loops[i]
    if (DrumParentCategories.Loops[category].includes(child) || category === child)
      return ['Loops', category]
  }

  return [null, null]
}

export const AllDrum = Array.from(
  new Set(
    [
      Object.keys(DrumParentCategories.OneShot),
      DrumParentCategories.OneShot.Kick,
      DrumParentCategories.OneShot.Snare,
      DrumParentCategories.OneShot.Hats,
      DrumParentCategories.OneShot.Percussion,
      DrumParentCategories.OneShot.Cymbal,
      DrumParentCategories.OneShot.Clap,
      DrumParentCategories.OneShot.Rim,
      DrumParentCategories.OneShot.Snap,
      DrumParentCategories.OneShot.Woodblock
    ].flat()
  )
)

export const AllLeadMelodic = Array.from(
  new Set(
    [
      MelodicParentCategories.Keys,
      MelodicParentCategories.Synth,
      MelodicParentCategories.Wind,
      MelodicParentCategories.Guitar,
      MelodicParentCategories.Strings,
      'Keys',
      'Synth',
      'Wind',
      'Guitar',
      'Strings'
    ].flat()
  )
)

export const AllMelodic = Array.from(
  new Set(
    [
      Object.keys(MelodicParentCategories),
      Object.keys(MelodicParentCategories).map((category) => {
        return MelodicParentCategories[category] as string[]
      })
    ]
      .flat()
      .flat()
  )
)

// TODO clean this up later. Need to define which categories users can set (base it on the spreadsheet)
// export const AllSampleCategories: string[] = dedupe(AllMelodic.concat(AllDrum))

export const SampleCategories = {
  ...MelodicParentCategories,
  ...DrumParentCategories.OneShot,
  ...DrumParentCategories.Loops
}
